<script setup lang="ts">
import { defineProps, type PropType, ref } from 'vue';
import { PhotographIcon } from '@heroicons/vue/outline';

const props = defineProps({
  // modelValue: { type: Object as PropType<File | null>, default: null },
  type: { type: String as PropType<'file' | 'directory'>, default: 'file' },
});
const { type } = toRefs(props);

const emit = defineEmits(['update:modelValue']);

const active = ref(false);

const drop = (e: any) => {
  active.value = false;
  const files = e.dataTransfer.files;
  emit('update:modelValue', type.value === 'directory' ? files : files[0]);
};
const selectedFile = () => {
  const files = (document.querySelector('#dropzoneFile') as any).files;
  emit('update:modelValue', type.value === 'directory' ? files : files[0]);
  (document.querySelector('#dropzoneFile') as any).value = '';
};
</script>

<template>
  <label
    id="dropzoneFileLabel"
    for="dropzoneFile"
    :class="[active ? 'border-neutral-400 dark:border-neutral-500' : 'border-neutral-300 dark:border-neutral-600']"
    class="relative block w-full cursor-pointer rounded-lg border-2 border-dashed p-24 text-center hover:border-neutral-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    @dragenter.prevent="active = true"
    @dragleave.prevent="active = false"
    @dragover.prevent
    @drop.prevent="drop"
  >
    <PhotographIcon
      :class="[active ? 'text-neutral-500 dark:text-neutral-400' : 'text-neutral-400 dark:text-neutral-500']"
      class="pointer-events-none mx-auto h-16 w-16"
    />
    <span class="pointer-events-none mt-2 block text-sm font-medium text-neutral-800 dark:text-neutral-100"
      >Drag & Drop or click to choose</span
    >
    <template v-if="type === 'file'">
      <div class="mt-1 text-xs text-neutral-500 dark:text-neutral-400">PNG, JPG, GIF, MP4, ...</div>
      <input id="dropzoneFile" type="file" class="hidden" accept="audio/*,video/*,image/*" @change="selectedFile" />
    </template>
    <template v-else>
      <div class="mt-1 text-xs text-neutral-500 dark:text-neutral-400">Directory</div>
      <input id="dropzoneFile" type="file" class="hidden" webkitdirectory @change="selectedFile" />
    </template>
  </label>
</template>
